module.exports = __webpack_public_path__ + "img/public/SiteIcons/steering-2.png?efe02af5";